
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  Tile,
  Grid,
  GridItem,
  Size,
} from '@drawbotics/react-drylus';
import sv from '@drawbotics/drylus-style-vars';
import Playground from '~/components/Playground';
export const CustomTile = () => {
  return <Tile title="Some title" mdxType="Tile">
      <div style={{
      height: 150,
      background: sv.grey100
    }} />
    </Tile>;
};

const layoutProps = {
  CustomTile
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Tile`}</h1>
<p>{`Used to display information in an enclosed context, often used with `}<inlineCode parentName="p">{`Grid`}</inlineCode>{` to create a "tiled" layout. Similar to a `}<inlineCode parentName="p">{`Card`}</inlineCode>{` but not clickable. It is also different from a `}<inlineCode parentName="p">{`Panel`}</inlineCode>{` as it has:`}</p>
<ul>
<li parentName="ul">{`1 title and some content, a `}<inlineCode parentName="li">{`Panel`}</inlineCode>{` can have many sections with titles`}</li>
<li parentName="ul">{`Lighter shadow for shorter elevation`}</li>
<li parentName="ul">{`Hard edges`}</li>
</ul>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Tile } from '@drawbotics/react-drylus';
`}</code></pre>
<Playground __position={0} __code={`<Tile title="Some title">
  <div style={{ height: 200, background: sv.grey100 }} />
</Tile>`} component={Tile} mdxType="Playground">
  <Tile title="Some title" mdxType="Tile">
    <div style={{
          height: 200,
          background: sv.grey100
        }} />
  </Tile>
</Playground>
<h3>{`Example with Grid`}</h3>

<Playground __position={1} __code={`<div
  style={{
    background: sv.backgroundColor,
    padding: '20px',
    margin: '-24px',
  }}>
  <Grid columns={3} hGutters={Size.DEFAULT} vGutters={Size.DEFAULT}>
    {[ ...Array(9) ].map((_, i) => (
      <GridItem key={i}>
        <CustomTile />
      </GridItem>
    ))}
  </Grid>
</div>`} mdxType="Playground">
  <div style={{
        background: sv.backgroundColor,
        padding: '20px',
        margin: '-24px'
      }}>
    <Grid columns={3} hGutters={Size.DEFAULT} vGutters={Size.DEFAULT} mdxType="Grid">
      {[...Array(9)].map((_, i) => <GridItem key={i} mdxType="GridItem">
          <CustomTile mdxType="CustomTile" />
        </GridItem>)}
    </Grid>
  </div>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;